import { render } from "./new-overtime.vue?vue&type=template&id=30274e51"
import script from "./new-overtime.vue?vue&type=script&lang=js"
export * from "./new-overtime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__